module.exports = __webpack_public_path__ + "static/group-6-fe3a5320f828ea64b95c0cecf50bdd2e.jpg";